import React, { useState } from "react";
import { api } from "../api";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const update = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/api/contact", form);
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page page-narrow">
      <div className="auth-card">
        <h1>Contact us</h1>
        {done ? (
          <div className="alert alert-success">
            Thanks for reaching out — we've received your message and will get back to you soon.
          </div>
        ) : (
          <form onSubmit={submit}>
            {error && <div className="alert alert-error">{error}</div>}
            <label>
              Name
              <input value={form.name} onChange={update("name")} required />
            </label>
            <label>
              Email
              <input type="email" value={form.email} onChange={update("email")} required />
            </label>
            <label>
              Message
              <textarea rows={5} value={form.message} onChange={update("message")} required />
            </label>
            <button className="btn btn-primary btn-block" disabled={busy}>
              {busy ? "Sending…" : "Send message"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
